import axios from "axios";
import { getSession } from "../authActions";
import { Apis, BaseUrl } from "../../config";
import { toast } from "react-toastify";

export const getAllSubscriptions = () => async (dispatch) => {
  const { token, user_profile_id } = getSession();

  dispatch({ type: "get_all_subscription_req" });
  try {
    const response = await axios.get(`${BaseUrl}${Apis.recurringPayment}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params: { user_profile_id },
    });
    if (response.data.result.rec) {
      const data = response.data.result.rec;
      const activeSubscription = data.find((p) => p.status === "active");
      const allSubscriptions = data.filter(
        (p) => p.status !== "active" && p.status !== "pending"
      );
      dispatch({
        type: "get_all_subscriptions_success",
        payload: { activeSubscription, allSubscriptions },
      });
    } else {
      throw new Error(response.data.result.message);
    }
  } catch (error) {
    dispatch({ type: "get_all_subscriptions_error" });
    console.log("========");
    console.log(error);
    const errorMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch subscriptionsX";
    if (errorMsg && errorMsg.trim()) {
      toast.error(errorMsg);
    }
  }
};

export const getRecentTransactions = () => async (dispatch) => {
  const { token, user_profile_id } = getSession();

  dispatch({ type: "get_recent_transactions_req" });
  try {
    const response = await axios.get(`${BaseUrl}${Apis.walletTransaction}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params: { user_profile_id },
    });
    if (response.data.result.rec) {
      dispatch({
        type: "get_recent_transactions_success",
        payload: response.data.result.rec.reverse(),
      });
    } else {
      throw new Error(response.data.result.message);
    }
  } catch (error) {
    dispatch({ type: "get_recent_transactions_error" });
    const errorMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch transactions";
    if (errorMsg && errorMsg.trim()) {
      toast.error(errorMsg);
    }
  }
};

export const getRecurringTypes = () => async (dispatch) => {
  const { token } = getSession();

  dispatch({ type: "get_recurring_types_req" });
  try {
    const response = await axios.get(
      `${BaseUrl}${Apis.recurringPaymentPricing}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "true",
        },
      }
    );
    if (response.data.result.rec) {
      dispatch({
        type: "get_recurring_types_success",
        payload: response.data.result.rec,
      });
    } else {
      throw new Error(response.data.result.message);
    }
  } catch (error) {
    dispatch({ type: "get_recurring_types_error" });
    const errorMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch recurring types";
    if (errorMsg && errorMsg.trim()) {
      toast.error(errorMsg);
    }
  }
};

export const handleAddFunds =
  (isRecurring, selectedOption, amount) => async (dispatch) => {
    const { token, user_profile_id } = getSession();
    dispatch({ type: "add_funds_req" });
    const postData = isRecurring
      ? {
          user_profile_id,
          order_tot_amt: selectedOption.amount,
          transaction_source: "recurring",
          price_id: selectedOption.price_id,
        }
      : {
          user_profile_id,
          transaction_type: "credit",
          order_tot_amt: amount,
          transaction_source: "one_time",
        };

    try {
      const response = await axios.post(
        `${BaseUrl}${Apis.createWalletTransaction}`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.session_url) {
        window.location.href = response.data.session_url;
      } else {
        throw new Error(response.data.message);
      }
      dispatch({ type: "add_funds_success" });
    } catch (error) {
      dispatch({ type: "add_funds_error" });
      const errorMsg =
        error.response?.data?.message || error.message || "Failed to add funds";
      if (errorMsg && errorMsg.trim()) {
        toast.error(errorMsg);
      }
    }
  };
